import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IObservation, IPatient } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AlertService } from '../../../../widgets/entry-components/alert/services/alert.service';

export const BLOODTYPES: string[] = ['0 -', 'A -', 'B -', 'AB -', '0 +', 'A +', 'B +', 'AB +'];

@Component({
  selector: 'inc-bloodtype-add',
  templateUrl: './bloodtype-add.component.html',
  styleUrls: ['./bloodtype-add.component.scss'],
})
export class BloodtypeAddComponent implements OnInit {
  bloodTypes = BLOODTYPES;
  selected = -1;
  @Input() obs: IObservation;
  @Input() user: any;
  @Input() patient: IPatient;
  @Output() callSave: EventEmitter<IObservation> = new EventEmitter();
  @Output() callUpdate: EventEmitter<IObservation> = new EventEmitter();
  @Output() callDelete: EventEmitter<string> = new EventEmitter();

  constructor(private alertService: AlertService) { }

  ngOnInit() {
    if (this.obs) { this.selected = this.bloodTypes.indexOf(this.obs.valueString); }
  }

  select(i: number) {
    if (i === this.selected) {
      this.alertService.presentShortDelete('BLOODTYPE_DELETE_ALERT', () => {
        this.callDelete.emit(this.obs.id);
      });
      return;
    }
    this.selected = i;

    if (!this.obs) {
      this.obs = this.createObs();
      this.alertService.presentBloodTypeAlert(false, () => {
        this.callSave.emit(this.obs);
      }, () => { this.selected = -1; });
    } else {
      this.alertService.presentBloodTypeAlert(true, () => {
        this.obs = this.patchObs(this.obs);
        this.callUpdate.emit(this.obs);
      }, () => { this.selected = -1; });
    }
  }

  createObs(): IObservation {
    return {
      id: null,
      resourceType: 'Observation',
      issued: new Date().toISOString(),
      performer: [{
        reference: this.user ? this.user.uid : '',
        display: this.user ? this.user.displayName : ''
      }],
      subject: {
        reference: this.patient ? this.patient.id : '',
        display: this.patient ? this.patient.name[0].text : ''
      },
      code: {
        coding: [{
          code: '882-1',
          display: 'ABO and Rh group [Type] in Blood]',
          system: 'http://loinc.org'
        }],
        text: 'bloodtype'
      },
      valueString: this.bloodTypes[this.selected] ? this.bloodTypes[this.selected] : ''
    };
  }

  patchObs(obs: IObservation): IObservation {
    obs.performer = [{
      reference: this.user ? this.user.uid : '',
      display: this.user ? this.user.displayName : ''
    }];
    obs.valueString = this.bloodTypes[this.selected] ? this.bloodTypes[this.selected] : '';
    return obs;
  }

}
